import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { resolveAstralIconAsset } from '../astral-icon-class.util';

@Component({
  selector: 'astral-translation-action',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <button
      class="astral-translation-action"
      [class.astral-translation-action--align-start]="alignStart"
      type="button"
      [attr.aria-label]="'TRANSLATE.TRANSLATE_BUTTON' | translate"
      [title]="'TRANSLATE.TRANSLATE_BUTTON' | translate"
      (click)="activate.emit()"
    >
      <img class="astral-translation-action__icon" [src]="iconAsset" alt="" aria-hidden="true" />
    </button>
  `,
  styleUrls: ['./astral-translation-action.component.scss'],
})
export class AstralTranslationActionComponent {
  readonly iconAsset = resolveAstralIconAsset('translate');

  @Input() alignStart = false;
  @Output() readonly activate = new EventEmitter<void>();
}
